<template>
  <div v-if="data" class="static-gif">
    <ProxyImage :img="data.background" @load="isBgFinish=true">
      <img
        v-for="(item,index) in data.gifs"
        :key="index"
        class="gif"
        :src="item.url"
        :style="item.style"
      />
    </ProxyImage>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProxyImage from './ProxyImg';
@Component({
  components: {
    ProxyImage,
  },
})
export default class StaticGif extends Vue {
  @Prop({ type: Object }) data!: any;
  isBgFinish = false;
}
</script>

<style lang="scss" scoped>
.static-gif {
  position: relative;
  .gif {
    position: absolute;
    left: 50%;
    width: 562.5px;
    border-radius: 16px;
    transform: translate(-50%, 0);
    // box-shadow: 0 0 9px 4px #eee;
  }
}
</style>